import axios from 'axios';
import { get, map, filter } from 'lodash';

import { getStorageUser } from '@utils/storage';

const CancelToken = axios.CancelToken;

export function checkPermissionRequest(config) {
  /**Get all permissions user have/ doesn't have as array
   * ex: ["!manage_workflows", "!manage_groups"];
   */
  const permissions = map(get(getStorageUser(), 'permissions'), 'name');

  /**Get only permissions user doesn't have access  */
  let notAllowed = filter(permissions, (permission) =>
    permission.includes('!'),
  );
  /**Get permissions user doesn't have access without !manage_ prefix
   * ex: ["workflows", "groups"]
   */
  notAllowed = map(notAllowed, (item) => item.replace('!manage_', ''));

  const apiUrl = config.url;
  const apiMethod = config.method;

  const notHaveAccess =
    notAllowed.some((item) => apiUrl.includes(item)) && apiMethod !== 'get';

  return {
    ...config,
    cancelToken:
      notHaveAccess &&
      new CancelToken((cancel) => cancel('Cancel request because permission')),
  };
}
